// noinspection DuplicatedCode

import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import {alertService} from "../../../services/AlertService";
import TableCard from "../../../components/tablecard/TableCard";
import ModalForm from "../../../components/modal/form/ModalForm";
import {getWaste, insertWaste, updateWaste, WasteSelector} from "./wasteSlice";

import {Colors} from "../../../assets/Colors";

const WastePage = ({}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [firstLoading, setFirstLoading] = useState(false);
    const [start, setStart] = useState(0);
    const [count, setCount] = useState(5);
    const [page, setPage] = useState(1);
    const [maxPage, setMaxPage] = useState(0);
    const [search, setSearch] = useState("");
    const [searchFetch, setSearchFetch] = useState(false);
    const [insertFetch, setInsertFetch] = useState(false);
    const [updateFetch, setUpdateFetch] = useState(false);
    const [showModalAdd, setShowModalAdd] = useState(false);
    const [showModalEdit, setShowModalEdit] = useState(false);
    const [currentData, setCurrentData] = useState({});

    const Waste = useSelector(WasteSelector);

    useEffect(() => {
        dispatch(
            getWaste({
                start: start,
                count: count,
                search: "",
            })
        );
    }, []);

    useEffect(() => {
        if (search !== "" && Waste.isGetSuccess && !Waste.isGetFetching) {
            let calc = Waste?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if (calc % count === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = Waste.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        } else if (search === "" && Waste.isGetSuccess && !Waste.isGetFetching) {
            let calc = Waste?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if (calc % count === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = Waste.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        }

        if (
            !Waste?.isGetFetching &&
            Waste.isGetSuccess &&
            maxPage === 0 &&
            firstLoading === false
        ) {
            let calc = Waste?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if (calc % count === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = Waste.data ? Math.ceil(calc / count) : 1;
            setMaxPage(tempMaxPage);
            setFirstLoading(true);
            dispatch(
                getWaste({
                    start: start,
                    count: count,
                    search: search,
                })
            );
        }

        if (insertFetch) {
            setInsertFetch(false);
            if (Waste.isGetSuccess) {
                alertService.success(Waste.message, {
                    autoClose: true,
                    keepAfterRouteChange: false,
                });
                dispatch(
                    getWaste({
                        start: start,
                        count: count,
                        search: search,
                    })
                );
            }
        }

        if (updateFetch) {
            setUpdateFetch(false);
            if (Waste.isUpdateSuccess) {
                alertService.success(Waste.message, {
                    autoClose: true,
                    keepAfterRouteChange: false,
                });
                dispatch(
                    updateWaste({
                        start: start,
                        count: count,
                        search: search,
                    })
                );
            }
        }
    });

    // function handleGetWaste(params) {
    //   return dispatch(getWaste(params));
    // }

    function handleInsertWaste(param) {
        setInsertFetch(true);
        const params = {
            WasteManagementName: param.inputOneValue,
            CategoryID: param.dropDownWasteValue,
        };
        // 
        dispatch(insertWaste(params));
    }

    function handleUpdateWaste(param) {
        setUpdateFetch(true);

        const params = {
            WasteManagementName: param.inputOneValue,
            WasteManagementID: currentData.WasteManagementID,
            status: param.status,
            CategoryID: param.dropDownWasteValue,
        };
        dispatch(updateWaste(params));
    }

    function handleSearch(searchValue) {
        let params = {
            start: 0,
            count: 5,
            search: searchValue,
        };
        dispatch(getWaste(params));

        setStart(0);
        setCount(5);
        setSearch(searchValue);
        setSearchFetch(true);
    }

    function handleUpdatePage(newPage) {
        let newStart = newPage * count - count;

        let params = {
            start: newStart,
            count: count,
            search: search,
        };
        dispatch(getWaste(params));

        setPage(newPage);
        setStart(newStart);
    }

    function handleUpdateCount(newCount) {
        let calc = Waste.count - 1;
        if (calc === 0) {
            calc = 1;
        }

        let params = {
            start: newCount === "-1" ? 0 : start,
            count: newCount === "-1" ? Waste.count : newCount,
            search: search,
        };
        dispatch(getWaste(params));

        setPage(1);
        setCount(newCount === "-1" ? Waste.count : newCount);
        setStart(newCount === "-1" ? 0 : start);
        setMaxPage(newCount === "-1" ? 1 : Math.ceil(calc / newCount));
    }

    function handleCurrentData(values) {
        setCurrentData(values);
    }

    function handleModal(status) {
        setShowModalAdd(status.showModalAdd);
        setShowModalEdit(status.showModalEdit);
    }

    if (!firstLoading) {
        return <div>loading</div>;
    } else {
        return (
            <div className="md:ml-64">
                <div
                    style={{background: Colors.primary}}
                    className="pt-14 pb-16 px-3 md:px-8 h-auto"
                >
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
                    </div>
                </div>

                <div className="px-3 md:px-8 h-auto -mt-32">
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 px-4">
                            <TableCard
                                backButton={true}
                                backUrl={"master"}
                                handleSearch={handleSearch}
                                searchPlaceholder="Waste"
                                updatePage={handleUpdatePage}
                                updateCount={handleUpdateCount}
                                currentData={handleCurrentData}
                                currentPage={page}
                                maxPage={maxPage}
                                tableTitle="Master Waste"
                                tableData={Waste.data}
                                colOneTitle="ID"
                                colOneData="WasteManagementID"
                                colTwoTitle="Nama Waste"
                                colTwoData="WasteManagementName"
                                colThreeTitle="Kelompok Waste"
                                colThreeData="CategoryName"
                                status="Status"
                                fetching={Waste.isGetFetching}
                                modal={handleModal}
                                editEnabled={true}
                            />
                        </div>
                    </div>
                </div>
                {showModalAdd && (
                    <ModalForm
                        dropDownWaste={true}
                        showModal={showModalAdd}
                        addEnabled={true}
                        modal={handleModal}
                        modalTitle="Tambah Waste"
                        inputOneTitle="Nama Waste"
                        inputOneValue=""
                        dropDownWasteValue=""
                        submitButtonTitle="Submit"
                        handleSubmit={handleInsertWaste}
                    />
                )}
                {showModalEdit && (
                    <ModalForm
                        dropDownWaste={true}
                        showModal={showModalEdit}
                        editEnabled={true}
                        id={currentData.WasteManagementID}
                        modal={handleModal}
                        modalTitle="Ubah Waste"
                        inputOneTitle="Nama Waste"
                        inputOneValue={currentData.WasteManagementName}
                        dropDownWasteValue={currentData.CategoryID}
                        status={currentData.Status}
                        submitButtonTitle="Submit"
                        handleSubmit={handleUpdateWaste}
                    />
                )}
            </div>
        );
    }
};

export default WastePage;
